import { ButtonVariantEnum } from "../../utils/enums/ButtonVariantEnum";
import { FontEnum } from "../../utils/enums/FontEnum";
import { useRef } from "react";

const BaseButton = ({
    onClick,
    variant,
    text,
    type,
    IconComponent,
    disabled = false,
    disableMessage,
}) => {
    const fileInputRef = useRef(null);

    const handlePaddingIfIconIsNotPresent = (style) => {
        let handledStyle = style;

        if (!IconComponent) {
            handledStyle = {
                ...handledStyle,
                mainContainer: {
                    ...handledStyle.mainContainer,
                    paddingRight: 20,
                },
            };
        }

        return handledStyle;
    };

    const getVariantStyle = () => {
        let style = null;

        if (variant === ButtonVariantEnum.WHITE) {
            style = styles.whiteVariantStyle;
        }

        if (variant === ButtonVariantEnum.BLACK) {
            style = styles.blackVariantStyle;
        }

        if (!style) {
            throw new Error("Invalid button variant provided");
        }

        style = handlePaddingIfIconIsNotPresent(style);
        return style;
    };

    const handleOnClick = () => {
        const fileSelectorButtonCondition =
            type === "file" && fileInputRef.current && !disabled;

        if (fileSelectorButtonCondition) {
            fileInputRef.current.click();
        } else if (!disabled) {
            onClick();
        }
    };

    const handleFileChange = (event) => {
        const files = event.target.files;

        const filesArray = [];

        for (let i = 0; i < files.length; i++) {
            const element = files[i];
            filesArray.push(element);
        }

        if (onClick) {
            onClick(filesArray);
        }
    };

    return (
        <div onClick={handleOnClick} style={getVariantStyle().mainContainer}>
            <p style={getVariantStyle().text}>{text}</p>

            {IconComponent && <IconComponent />}

            {type === "file" && (
                <input
                    type="file"
                    accept="image/png, image/gif, image/jpeg"
                    multiple
                    ref={fileInputRef}
                    style={styles.hiddenInput}
                    onChange={handleFileChange}
                />
            )}
        </div>
    );
};

export default BaseButton;

const styles = {
    whiteVariantStyle: {
        mainContainer: {
            cursor: "pointer",
            display: "flex",
            width: "max-content",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: 20,
            paddingTop: 10,
            paddingBottom: 10,
            borderWidth: 2.5,
            borderColor: "#171718",
            borderStyle: "solid",
            borderRadius: 8,
        },
        text: {
            fontFamily: FontEnum.TITILIUM_WEB,
            fontWeight: 700,
            fontSize: "20px",
            color: "#171718",
        },
    },

    blackVariantStyle: {
        mainContainer: {
            cursor: "pointer",
            display: "flex",
            width: "max-content",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: 20,
            paddingTop: 10,
            paddingBottom: 10,
            borderWidth: 2,
            borderColor: "#171718",
            borderStyle: "solid",
            borderRadius: 8,
            backgroundColor: "#171718",
        },
        text: {
            fontFamily: FontEnum.TITILIUM_WEB,
            fontWeight: 700,
            fontSize: "20px",
            color: "#FFFFFF",
        },
    },

    hiddenInput: {
        display: "none",
    },
};
